import "@vidstack/react/player/styles/base.css";
import "@vidstack/react/player/styles/plyr/theme.css";
import "./styles.scss";

import { MediaPlayer, MediaProvider, useMediaState } from "@vidstack/react";
import {
  PlyrLayout,
  plyrLayoutIcons,
} from "@vidstack/react/player/layouts/plyr";
import clsx from "clsx";
import { memo, useRef } from "react";

import classes from "./styles.module.scss";

import type { MediaPlayerInstance } from "@vidstack/react";

import type { IVideoPlayerProps } from "@atoms/videoPlayer/types";

import "ldrs/ring2";

export const VideoPlayer = memo(function VideoPlayer({
  src,
  title,
}: IVideoPlayerProps) {
  const player = useRef<MediaPlayerInstance>(null);

  const canPlay = useMediaState("canPlay", player);

  return (
    <MediaPlayer
      ref={player}
      title={title}
      src={src}
      viewType={"video"}
      streamType={"on-demand"}
      logLevel={"warn"}
      crossOrigin
      playsInline
      load={"visible"}
      preload={"metadata"}
    >
      <MediaProvider />
      <PlyrLayout icons={plyrLayoutIcons} />
      {!canPlay && (
        <div className={clsx(classes.loaderContainer)}>
          <l-ring-2
            size={"60"}
            stroke={"6"}
            stroke-length={"0.25"}
            bg-opacity={"0.3"}
            speed={"0.8"}
            color={"white"}
          />
        </div>
      )}
    </MediaPlayer>
  );
});
